import { Component } from '@angular/core';
import { DialogModule } from '@cpd-app/shared-module/components/dialog/dialog.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'cpd-chat-info-dialog',
  templateUrl: './chat-info-dialog.component.html',
  styleUrls: ['./chat-info-dialog.component.scss'],
  imports: [DialogModule, FontAwesomeModule],
  standalone: true
})
export class ChatInfoDialogComponent {}
